// extracted by mini-css-extract-plugin
export default {"backButton":"WebUrlView_backButton__SNF2d"};